import type { ActivityRatingScale, ActivityType } from '@/api/types/jobEnd.types';

// Row numbering is derived from position at render time, not baked in here, because the
// applicable set differs per Job End and each set numbers from 1.
export const ACTIVITY_LABELS: Record<ActivityType, string> = {
  DeskBasedResearch: 'Desk-based research',
  FieldBasedResearch: 'Field-based research',
  InterviewingThirdParties: 'Interviewing third parties',
  FinancialModelling: 'Financial Modelling',
  ExcelModelling: 'Excel Modelling',
  DataManipulation: 'Data Manipulation',
  AdvancedModelling: 'Advanced Modelling',
  CloseWorkingWithClient: 'Close working with client',
  ManagementOfJrStaff: 'Management of Jr. Staff',

  ResearchAndDataGathering: 'Research & data gathering',
  DatasetAnalysis: 'Dataset analysis',
  ProblemStructuring: 'Problem structuring',
  WrittenDeliverables: 'Developing and crafting of written deliverables',
  PresentationInternal: 'Presentation (internally)',
  MarketFinancialModelling: 'Market / financial modelling',
  Interviewing: 'Interviewing',
  PresentationExternal: 'Presentation (externally)',
  JuniorStaffSupport: 'Support & development of junior staff',

  ComplexAnalysisModelling: 'Complex analysis / modelling',
  Storyline: 'Developing and crafting of the storyline',
  PresentationToClients: 'Presentation to clients',
  ClientCollaboration: 'Client collaboration',
  JuniorStaffManagement: 'Management & development of junior staff',
};

// Used where the label is a column header rather than a row label and space is tight.
export const ACTIVITY_LABELS_SHORT: Record<ActivityType, string> = {
  DeskBasedResearch: 'Desk-Based Research',
  FieldBasedResearch: 'Field-Based Research',
  InterviewingThirdParties: 'Interviewing 3rd Parties',
  FinancialModelling: 'Financial Modelling',
  ExcelModelling: 'Excel Modelling',
  DataManipulation: 'Data Manipulation',
  AdvancedModelling: 'Advanced Modelling',
  CloseWorkingWithClient: 'Close Working with Client',
  ManagementOfJrStaff: 'Mgmt of Jr. Staff',

  ResearchAndDataGathering: 'Research & Data Gathering',
  DatasetAnalysis: 'Dataset Analysis',
  ProblemStructuring: 'Problem Structuring',
  WrittenDeliverables: 'Written Deliverables',
  PresentationInternal: 'Presentation (Internal)',
  MarketFinancialModelling: 'Market / Financial Modelling',
  Interviewing: 'Interviewing',
  PresentationExternal: 'Presentation (External)',
  JuniorStaffSupport: 'Support of Junior Staff',

  ComplexAnalysisModelling: 'Complex Analysis / Modelling',
  Storyline: 'Storyline',
  PresentationToClients: 'Presentation to Clients',
  ClientCollaboration: 'Client Collaboration',
  JuniorStaffManagement: 'Mgmt of Junior Staff',
};

export const ACTIVITY_RATING_OPTIONS: ActivityRatingScale[] = ['NT', 'PT', 'FT'];

export const ACTIVITY_RATING_LABELS: Record<ActivityRatingScale, string> = {
  NT: 'Not Tested',
  PT: 'Lightly Tested',
  FT: 'Well Tested',
};

// Used where only a value cell is available and the full label will not fit, such as the Project
// Roles table. The stored values stay NT/PT/FT, so PT and FT abbreviate to LT and WT here.
export const ACTIVITY_RATING_ABBREVIATIONS: Record<ActivityRatingScale, string> = {
  NT: 'NT',
  PT: 'LT',
  FT: 'WT',
};
